<template>
  <div>
    <v-alert
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
    >
      <h1 class="mb-5">
        現在、システムメンテナンス中です。
      </h1>
      <div>
        <p>健康チャレンジキャンペーンは、システムメンテナンス中の為、ご利用できません。</p>
        <p>大変ご迷惑をおかけしますが、しばらく時間をあけてアクセスしてください。</p>
        <p style="white-space:pre-wrap;" v-text="maintenance"></p>
      </div>
    </v-alert>
  </div>
</template>
<script>
// この画面は運用では利用しない
// 運用にて利用するのは、public/maintenance.html
import Vue from 'vue'
export default Vue.extend({
  name: 'Maintenance',
  props: ['config'],
  components: {
  },
  data () {
    return {
      maintenance: ''
    }
  },
  computed: {},
  mounted () {
    this.getMaintenanceJson()
  },
  methods: {
    // cloudfront→S3からjsonファイルのメンテナンス情報を取得(手動でS3にファイルを格納する)
    getMaintenanceJson () {
      const url = process.env.VUE_APP_CAMPAIGNLIST_URL + '/maintenance.json'
      var xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.open('GET', url, true)
      xmlHttpRequest.responseType = 'json'
      xmlHttpRequest.send(null)
      const me = this
      xmlHttpRequest.onreadystatechange = function () {
        if (this.readyState === 4 && this.status === 200) {
          if (this.response) {
            const userAgent = window.navigator.userAgent.toUpperCase()
            let maintenanceObj = ''
            if (userAgent.indexOf('MSIE') === -1 && userAgent.indexOf('TRIDENT') === -1) {
              maintenanceObj = this.response
            } else {
              maintenanceObj = JSON.parse(this.response)
            }
            me.maintenance = maintenanceObj.description
          }
        }
      }
    }
  }
})
</script>
